import { render } from "./notice-list.vue?vue&type=template&id=4262c797&scoped=true&ts=true"
import script from "./notice-list.vue?vue&type=script&lang=ts"
export * from "./notice-list.vue?vue&type=script&lang=ts"

import "./notice-list.vue?vue&type=style&index=0&id=4262c797&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4262c797"]])

export default __exports__